// extracted by mini-css-extract-plugin
module.exports = {"loader":"GetData_loader__9iR5F"};